import { useTranslation } from 'react-i18next'

import { RentalPortalOverviewPanel } from '../../RentalPortalOverviewPanel'
import { OVERVIEW_PANEL_LIST } from '../../RentalPortalOverviewPanels.constants'
import { getOverviewPanelOverlayTitles } from '../../RentalPortalOverviewPanels.utils'

export function useRentalPortalOverviewPanelWidgets({
  isLoading,
  overview,
  onRetryPanel,
}) {
  const { t } = useTranslation()

  const widgets = Object.fromEntries(
    OVERVIEW_PANEL_LIST.map(panel => [
      panel.field,
      dragHandleProps => (
        <RentalPortalOverviewPanel
          dragHandleProps={dragHandleProps}
          isLoading={isLoading}
          overview={overview}
          panel={panel}
          onRetry={onRetryPanel}
        />
      ),
    ])
  )

  return { overlayTitles: getOverviewPanelOverlayTitles(t), widgets }
}
